// extracted by mini-css-extract-plugin
module.exports = {"collapse":"CollapseChevron_collapse__tG5fG","floatRight":"CollapseChevron_floatRight__vWU6Z"};